// LOGIN
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_LOADING = "CHANGE_PASSWORD_LOADING";
export const CHANGE_PASSWORD_RESPONSE = "CHANGE_PASSWORD_RESPONSE";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const FORGOT_PASSWORD_LOADING = "FORGOT_PASSWORD_LOADING";
export const FORGOT_PASSWORD_RESPONSE = "FORGOT_PASSWORD_RESPONSE";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_LOADING = 'LOGIN_LOADING';
export const LOGIN_RESPONSE = "LOGIN_RESPONSE";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_USER_LICENSE_AGREEMENT_STATUS = "UPDATE_USER_LICENSE_AGREEMENT_STATUS";
export const UPDATE_USER_LICENSE_AGREEMENT_STATUS_ERROR = "UPDATE_USER_LICENSE_AGREEMENT_STATUS_ERROR";
export const UPDATE_USER_LICENSE_AGREEMENT_STATUS_LOADING = "UPDATE_USER_LICENSE_AGREEMENT_STATUS_LOADING";
export const UPDATE_USER_PASSWORD_CHANGE_REQUIRED_STATUS = "UPDATE_USER_PASSWORD_CHANGE_REQUIRED_STATUS";
// ASSET
export const ADD_SUPER_ASSET_COMMENT = "ADD_SUPER_ASSET_COMMENT";
export const ADD_SUPER_ASSET_COMMENT_ERROR = "ADD_SUPER_ASSET_COMMENT_ERROR";
export const ADD_SUPER_ASSET_COMMENT_LOADING = "ADD_SUPER_ASSET_COMMENT_LOADING";
export const ADD_ASSET_COMMENT = "ADD_ASSET_COMMENT";
export const ADD_ASSET_COMMENT_ERROR = "ADD_ASSET_COMMENT_ERROR";
export const ADD_ASSET_COMMENT_LOADING = "ADD_ASSET_COMMENT_LOADING";
export const ADD_LATEST_COMMENT_IN_SENSOR_LIST = "ADD_LATEST_COMMENT_IN_SENSOR_LIST";
export const ADD_LATEST_COMMENT_IN_ASSET_DETAILS = "ADD_LATEST_COMMENT_IN_ASSET_DETAILS";
export const ASSET_COMMENTS = "ASSET_COMMENTS";
export const ASSET_COMMENTS_ERROR = "ASSET_COMMENTS_ERROR";
export const ASSET_COMMENTS_LOADING = "ASSET_COMMENTS_LOADING";
export const ASSET_COUNT = "ASSET_COUNT";
export const ASSET_COUNT_ERROR = "ASSET_COUNT_ERROR";
export const ASSET_COUNT_LOADING = "ASSET_COUNT_LOADING";
export const ASSET_CONDITION_INFO = "ASSET_CONDITION_INFO";
export const ASSET_CONDITION_INFO_ERROR = "ASSET_CONDITION_INFO_ERROR";
export const ASSET_CONDITION_INFO_LOADING = "ASSET_CONDITION_INFO_LOADING";
export const ASSET_DETAILS = "ASSET_DETAILS";
export const ASSET_DETAILS_ERROR = "ASSET_DETAILS_ERROR";
export const ASSET_DETAILS_LOADING = "ASSET_DETAILS_LOADING";
export const ASSET_DOWNLOAD_MEASUREMENT_DATA_ERROR = "ASSET_DOWNLOAD_MEASUREMENT_DATA_ERROR";
export const ASSET_DOWNLOAD_MEASUREMENT_DATA_LOADING = "ASSET_DOWNLOAD_MEASUREMENT_DATA_LOADING";
export const ASSET_GRAPH_CURRENT_DATA = "ASSET_GRAPH_CURRENT_DATA";
export const ASSET_GRAPH_HISTORICAL_DATA = "ASSET_GRAPH_HISTORICAL_DATA";
export const ASSET_GRAPH_ERROR = "ASSET_GRAPH_ERROR";
export const ASSET_GRAPH_LOADING = "ASSET_GRAPH_LOADING";
export const ASSET_LIST = "ASSET_LIST";
export const ASSET_LIST_ERROR = "ASSET_LIST_ERROR";
export const ASSET_LIST_LOADING = "ASSET_LIST_LOADING";
export const CENTER_DATE_TIME_LIST = "CENTER_DATE_TIME_LIST";
export const CENTER_DATE_TIME_LIST_ERROR = "CENTER_DATE_TIME_LIST_ERROR";
export const CENTER_DATE_TIME_LIST_LOADING = "CENTER_DATE_TIME_LIST_LOADING";
export const EXPORT_SENSOR_LIST_ERROR = "EXPORT_SENSOR_LIST_ERROR";
export const EXPORT_SENSOR_LIST_LOADING = "EXPORT_SENSOR_LIST_LOADING";
export const FAULT_ENUMS_LIST = "FAULT_ENUMS_LIST";
export const FAULT_ENUM_LIST_ERROR = "FAULT_ENUM_LIST_ERROR";
export const FAULT_ENUM_LIST_LOADING = "FAULT_ENUM_LIST_LOADING";
export const METRICS_LIST = "METRICS_LIST";
export const METRICS_LIST_ERROR = "METRICS_LIST_ERROR";
export const METRICS_LIST_LOADING = "METRICS_LIST_LOADING";
export const ADD_PLOTLY_GRAPH_AND_TABLE_JSON = "ADD_PLOTLY_GRAPH_AND_TABLE_JSON";
export const PLOTLY_GRAPH_AND_TABLE_JSON = "PLOTLY_GRAPH_AND_TABLE_JSON";
export const PLOTLY_GRAPH_AND_TABLE_JSON_ERROR = "PLOTLY_GRAPH_AND_TABLE_JSON_ERROR";
export const PLOTLY_GRAPH_AND_TABLE_JSON_LOADING = "PLOTLY_GRAPH_AND_TABLE_JSON_LOADING";
export const QUICK_FEEDBACK_RESPONSE = "QUICK_FEEDBACK_RESPONSE";
export const QUICK_FEEDBACK_ERROR = "QUICK_FEEDBACK_ERROR";
export const QUICK_FEEDBACK_LOADING = "QUICK_FEEDBACK_LOADING";
export const SUPER_ASSET_COMMENTS = "SUPER_ASSET_COMMENTS";
export const SUPER_ASSET_COMMENTS_ERROR = "SUPER_ASSET_COMMENTS_ERROR";
export const SUPER_ASSET_COMMENTS_LOADING = "SUPER_ASSET_COMMENTS_LOADING";
export const UPDATE_MOTE_STATE = "UPDATE_MOTE_STATE";
export const UPDATE_MOTE_STATE_ERROR = "UPDATE_MOTE_STATE_ERROR";
export const UPDATE_MOTE_STATE_LOADING = "UPDATE_MOTE_STATE_LOADING";
export const UPDATE_CUST_ASSET_TAG = "UPDATE_CUST_ASSET_TAG";
export const UPDATE_CUST_ASSET_TAG_ERROR = "UPDATE_CUST_ASSET_TAG_ERROR";
export const UPDATE_CUST_ASSET_TAG_LOADING = "UPDATE_CUST_ASSET_TAG_LOADING";
export const FETCH_SUPER_ASSET_IMAGES = "FETCH_SUPER_ASSET_IMAGES";
export const FETCH_SUPER_ASSET_IMAGES_ERROR = "FETCH_SUPER_ASSET_IMAGES_ERROR";
export const FETCH_SUPER_ASSET_IMAGES_LOADING = "FETCH_SUPER_ASSET_IMAGES_LOADING";
export const FETCH_ASSET_IMAGES = "FETCH_ASSET_IMAGES";
export const FETCH_ASSET_IMAGES_ERROR = "FETCH_ASSET_IMAGES_ERROR";
export const FETCH_ASSET_IMAGES_LOADING = "FETCH_ASSET_IMAGES_LOADING";
export const DELETE_SUPER_ASSET_IMAGE_ERROR = "DELETE_SUPER_ASSET_IMAGE_ERROR";
export const DELETE_SUPER_ASSET_IMAGE_LOADING = "DELETE_SUPER_ASSET_IMAGE_LOADING";
export const DELETE_SUPER_ASSET_IMAGE = "DELETE_SUPER_ASSET_IMAGE";
export const DELETE_ASSET_IMAGE_ERROR = "DELETE_ASSET_IMAGE_ERROR";
export const DELETE_ASSET_IMAGE_LOADING = "DELETE_ASSET_IMAGE_LOADING";
export const DELETE_ASSET_IMAGE = "DELETE_ASSET_IMAGE";
export const UPDATE_SUPER_ASSET_ALTERNATE_ID_ERROR = "UPDATE_SUPER_ASSET_ALTERNATE_ID_ERROR";
export const UPDATE_SUPER_ASSET_ALTERNATE_ID_LOADING = "UPDATE_SUPER_ASSET_ALTERNATE_ID_LOADING";
export const UPDATE_SUPER_ASSET_ALTERNATE_ID = "UPDATE_SUPER_ASSET_ALTERNATE_ID";

//CUSTOMER
export const CUSTOMER_LIST = "CUSTOMER_LIST";
export const CUSTOMER_LIST_ERROR = "CUSTOMER_LIST_ERROR";
export const CUSTOMER_LIST_LOADING = "CUSTOMER_LIST_LOADING";

//FEED
export const ASSET_FEED_LIST = "ASSET_FEED_LIST";
export const ASSET_FEED_FOLLOW_OR_UNFOLLOW = "ASSET_FEED_FOLLOW_OR_UNFOLLOW";
export const ADD_FEED_COMMENT = "ADD_FEED_COMMENT";
export const ADD_FEED_COMMENT_ERROR = "ADD_FEED_COMMENT_ERROR";
export const ADD_FEED_COMMENT_LOADING = "ADD_FEED_COMMENT_LOADING";
export const ADD_USER_FEED = "ADD_USER_FEED";
export const ADD_USER_FEED_ERROR = "ADD_USER_FEED_ERROR";
export const ADD_USER_FEED_LOADING = "ADD_USER_FEED_LOADING";
export const FEED_COMMENT = "FEED_COMMENT";
export const FEED_COMMENT_ERROR = "FEED_COMMENT_ERROR";
export const FEED_COMMENT_LOADING = "FEED_COMMENT_LOADING"
export const FEED_FOLLOW_OR_UNFOLLOW = "FEED_FOLLOW_OR_UNFOLLOW";
export const FEED_FOLLOW_OR_UNFOLLOW_ERROR = "FEED_FOLLOW_OR_UNFOLLOW_ERROR";
export const FEED_FOLLOW_OR_UNFOLLOW_LOADING = "FEED_FOLLOW_OR_UNFOLLOW_LOADING";
export const FEED_LIST = "FEED_LIST";
export const FEED_LIST_ERROR = "FEED_LIST_ERROR";
export const FEED_LIST_LOADING = "FEED_LIST_LOADING";
export const FEEDS_LAST_UPDATED_DATE_TIME = "FEEDS_LAST_UPDATED_DATE_TIME";
export const NEW_FEED_LIST = "NEW_FEED_LIST";
export const NEW_FEEDS_COUNT = "NEW_FEEDS_COUNT";
export const REFRESH_FEED_LIST_ERROR = "REFRESH_FEED_LIST_ERROR";
export const REFRESH_FEED_LIST_LOADING = "REFRESH_FEED_LIST_LOADING";
export const REMOVE_FEED_LIST = "REMOVE_FEED_LIST";
export const REMOVE_FEED_BY_EVENT_ID = "REMOVE_FEED_BY_EVENT_ID";
export const REMOVE_ASSET_HISTORY_FEED_BY_EVENT_ID = "REMOVE_ASSET_HISTORY_FEED_BY_EVENT_ID";
export const REMOVE_NEW_FEED_BY_EVENT_ID = "REMOVE_NEW_FEED_BY_EVENT_ID";
export const REMOVE_NEW_FEEDS_BY_FEED_TYPE = "REMOVE_NEW_FEEDS_BY_FEED_TYPE";
export const REMOVE_NEW_FEEDS = "REMOVE_NEW_FEEDS";
export const UPDATE_NEW_FEEDS_INTO_OLD_FEEDS_LOADING = "UPDATE_NEW_FEEDS_INTO_OLD_FEEDS_LOADING";
export const UPDATE_NEW_FEEDS_INTO_OLD_FEEDS = "UPDATE_NEW_FEEDS_INTO_OLD_FEEDS";
export const UPDATE_NEW_ASSET_HISTORY_FEEDS_INTO_OLD_ASSET_HISTORY_FEEDS = "UPDATE_NEW_ASSET_HISTORY_FEEDS_INTO_OLD_ASSET_HISTORY_FEEDS";
export const LAST_SELECTED_CUSTOMER_ID = "LAST_SELECTED_CUSTOMER_ID";

// SENSOR
export const REPLACE_SENSOR = "REPLACE_SENSOR";
export const REPLACE_SENSOR_ERROR = "REPLACE_SENSOR_ERROR";
export const REPLACE_SENSOR_LOADING = "REPLACE_SENSOR_LOADING";
export const SENSOR_HISTORY = "SENSOR_HISTORY";
export const SENSOR_HISTORY_ERROR = "SENSOR_HISTORY_ERROR";
export const SENSOR_HISTORY_LOADING = "SENSOR_HISTORY_LOADING";
export const SENSOR_LIST = "SENSOR_LIST";
export const SENSOR_LIST_ERROR = "SENSOR_LIST_ERROR";
export const SENSOR_LIST_LOADING = "SENSOR_LIST_LOADING";
export const UPDATE_SENSOR_UNRESPONSIVE_REASON = "UPDATE_SENSOR_UNRESPONSIVE_REASON";
export const UPDATE_SENSOR_UNRESPONSIVE_REASON_ERROR= "UPDATE_SENSOR_UNRESPONSIVE_REASON_ERROR";
export const UPDATE_SENSOR_UNRESPONSIVE_REASON_LOADING = "UPDATE_SENSOR_UNRESPONSIVE_REASON_LOADING";
export const SENSOR_UNRESPONSIVE_REASON_LIST = "SENSOR_UNRESPONSIVE_REASON_LIST";
export const SENSOR_UNRESPONSIVE_REASON_LIST_ERROR = "SENSOR_UNRESPONSIVE_REASON_LIST_ERROR";
export const SENSOR_UNRESPONSIVE_REASON_LIST_LOADING = "SENSOR_UNRESPONSIVE_REASON_LIST_LOADING";
export const FETCH_UNATTACHED_SENSOR_LIST = "FETCH_UNATTACHED_SENSOR_LIST";
export const FETCH_UNATTACHED_SENSOR_LIST_ERROR = "FETCH_UNATTACHED_SENSOR_LIST_ERROR";
export const FETCH_UNATTACHED_SENSOR_LIST_LOADING = "FETCH_UNATTACHED_SENSOR_LIST_LOADING";
export const UPDATE_SENSOR_INFO = "UPDATE_SENSOR_INFO";
export const UPDATE_SENSOR_INFO_ERROR = "UPDATE_SENSOR_INFO_ERROR";
export const UPDATE_SENSOR_INFO_LOADING = "UPDATE_SENSOR_INFO_LOADING";
export const DETACH_SENSOR = "DETACH_SENSOR";
export const DETACH_SENSOR_ERROR = "DETACH_SENSOR_ERROR";
export const DETACH_SENSOR_LOADING = "DETACH_SENSOR_LOADING";
export const ADD_SENSOR = "ADD_SENSOR";
export const ADD_SENSOR_ERROR = "ADD_SENSOR_ERROR";
export const ADD_SENSOR_LOADING = "ADD_SENSOR_LOADING";
export const GET_PROGRAM_ID_LOADING = "GET_PROGRAM_ID_LOADING";
export const GET_PROGRAM_ID = "GET_PROGRAM_ID";
export const GET_PROGRAM_ID_ERROR = "GET_PROGRAM_ID_ERROR";

//TICKET
export const ADD_TICKET_COMMENT_ERROR = "ADD_TICKET_COMMENT_ERROR";
export const ADD_TICKET_COMMENT_LOADING = "ADD_TICKET_COMMENT_LOADING";
export const ADD_TICKET_FEEDBACK = "ADD_TICKET_FEEDBACK";
export const ADD_TICKET_FEEDBACK_ERROR = "ADD_TICKET_FEEDBACK_ERROR";
export const ADD_TICKET_FEEDBACK_LOADING = "ADD_TICKET_FEEDBACK_LOADING";
export const ASSIGN_USER_TO_TICKET = "ASSIGN_USER_TO_TICKET";
export const ASSIGN_USER_TO_TICKET_ERROR = "ASSIGN_USER_TO_TICKET_ERROR";
export const ASSIGN_USER_TO_TICKET_LOADING = "ASSIGN_USER_TO_TICKET_LOADING";
export const CREATE_TICKET_STATUS = "CREATE_TICKET_STATUS";
export const CREATE_TICKET_ERROR = "CREATE_TICKET_ERROR";
export const CREATE_TICKET_LOADING = "CREATE_TICKET_LOADING";
export const FEEDBACK_HISTORY = "FEEDBACK_HISTORY";
export const ADD_TICKET_FEEDBACK_HISTORY = "ADD_TICKET_FEEDBACK_HISTORY";
export const FEEDBACK_HISTORY_ERROR = "FEEDBACK_HISTORY_ERROR";
export const FEEDBACK_HISTORY_LOADING = "FEEDBACK_HISTORY_LOADING";
export const TICKET_CLOSE_OR_REOPEN = "TICKET_CLOSE_OR_REOPEN";
export const TICKET_CLOSE_OR_REOPEN_ERROR = "TICKET_CLOSE_OR_REOPEN_ERROR";
export const TICKET_CLOSE_OR_REOPEN_LOADING = "TICKET_CLOSE_OR_REOPEN_LOADING";
export const TICKET_DETAILS = "TICKET_DETAILS";
export const TICKET_DETAILS_ERROR = "TICKET_DETAILS_ERROR";
export const TICKET_DETAILS_LOADING = "TICKET_DETAILS_LOADING";
export const FEEDBACK_FILES_BY_TICKET_ID = "FEEDBACK_FILES_BY_TICKET_ID";
export const FEEDBACK_FILES_BY_TICKET_ID_ERROR = "FEEDBACK_FILES_BY_TICKET_ID_ERROR";
export const FEEDBACK_FILES_BY_TICKET_ID_LOADING = "FEEDBACK_FILES_BY_TICKET_ID_LOADING";
export const CLEAR_FEEDBACK_FILES = "CLEAR_FEEDBACK_FILES";

//USER
export const USER_DETAILS = "USER_DETAILS";
export const USER_DETAILS_ERROR = "USER_DETAILS_ERROR";
export const USER_DETAILS_LOADING = "USER_DETAILS_LOADING";
export const USER_LIST = "USER_LIST";
export const USER_LIST_ERROR = "USER_LIST_ERROR";
export const USER_LIST_LOADING = "USER_LIST_LOADING";


//APP COMMON ACTIONS
export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const FULL_SCREEN = 'FULL_SCREEN';
export const FULL_SCREEN_EXIT = 'FULL_SCREEN_EXIT';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';

export const SENSOR_STATE = "SENSOR_STATE";
export const SELECTED_SENSOR = "SELECTED_SENSOR";
export const SUPER_ASSET = "SUPER_ASSET";
export const SELECTED_CONDITION = "SELECTED_CONDITION";
export const CUSTOMER_ID = "CUSTOMER_ID";
export const ASSET_DOWNLOAD_MEASUREMENT_START_DATE = "ASSET_DOWNLOAD_MEASUREMENT_START_DATE";
export const ASSET_DOWNLOAD_MEASUREMENT_END_DATE = "ASSET_DOWNLOAD_MEASUREMENT_END_DATE";
export const ASSET_GRAPH_TYPE = "ASSET_GRAPH_TYPE";
export const ASSET_GRAPH_PARAM = "ASSET_GRAPH_PARAM";
export const ASSET_LIST_SEARCH_INPUT = "ASSET_LIST_SEARCH_INPUT";
export const SENSOR_LIST_SEARCH_INPUT = "SENSOR_LIST_SEARCH_INPUT";
export const STORE_SENSOR_UNRESPONSIVE_REASON_FILTER = 'STORE_SENSOR_UNRESPONSIVE_REASON_FILTER';
export const CLEAR_SENSOR_UNRESPONSIVE_REASON_FILTER = 'CLEAR_SENSOR_UNRESPONSIVE_REASON_FILTER';
export const SHOW_DECOMMISSIONED_ASSETS = "SHOW_DECOMMISSIONED_ASSETS";
export const SUPER_ASSET_SEARCH_INPUT = "SUPER_ASSET_SEARCH_INPUT";
export const ASSET_PLOTLY_VIEW_TYPE = "ASSET_PLOTLY_VIEW_TYPE";
export const ASSET_PLOTLY_CENTER_DATE_TIME = "ASSET_PLOTLY_CENTER_DATE_TIME";
export const ASSET_PLOTLY_FREQUENCY_TYPE = "ASSET_PLOTLY_FREQUENCY_TYPE";
export const ASSET_PLOTLY_METRIC_TYPE = "ASSET_PLOTLY_METRIC_TYPE";
export const ASSET_PLOTLY_GRAPH_PARAMS = "ASSET_PLOTLY_GRAPH_PARAMS";
export const ASSET_PLOTLY_TABLE_PARAMS = "ASSET_PLOTLY_TABLE_PARAMS";
export const SELECTED_FEED = "SELECTED_FEED";
export const SHOW_MORE_TICKETS_IN_ASSET_DETAILS = "SHOW_MORE_TICKETS_IN_ASSET_DETAILS";
export const SHOW_MORE_TICKETS_IN_TICKET_DETAILS = "SHOW_MORE_TICKETS_IN_TICKET_DETAILS";
export const UPDATE_SCREEN_CONTEXT = "UPDATE_SCREEN_CONTEXT";
export const SELECTED_USER = "SELECTED_USER";
export const USER_LIST_SEARCH_INPUT = "USER_LIST_SEARCH_INPUT";
export const TICKET_ID_AND_ASSET_ID = "TICKET_ID_AND_ASSET_ID";
export const FEED_FILTER_BUTTON_STATE = "FEED_FILTER_BUTTON_STATE";
export const INCLUDE_SUPER_ASSET_TO_LIST_BASED_ON_TREND_FLAG = "INCLUDE_SUPER_ASSET_TO_LIST_BASED_ON_TREND_FLAG";

export const UPDATE_ASSET_IMAGE = "UPDATE_ASSET_IMAGE";
export const UPDATE_SUPER_ASSET_IMAGE = "UPDATE_SUPER_ASSET_IMAGE";
export const SAVE_IMAGE_ROTATION_ERROR = "SAVE_IMAGE_ROTATION_ERROR";
export const SAVE_IMAGE_ROTATION_LOADING = "SAVE_IMAGE_ROTATION_LOADING";

export const FETCH_FEEDBACK_TAGS = "FETCH_FEEDBACK_TAGS";
export const FETCH_FEEDBACK_TAGS_ERROR = "FETCH_FEEDBACK_TAGS_ERROR";
export const FETCH_FEEDBACK_TAGS_LOADING = "FETCH_FEEDBACK_TAGS_LOADING";

export const DOWNLOAD_FEEDBACK_FILES_ERROR = "DOWNLOAD_FEEDBACK_FILES_ERROR";
export const DOWNLOAD_FEEDBACK_FILES_LOADING = "DOWNLOAD_FEEDBACK_FILES_LOADING";
export const SELECTED_FEEDBACK_FILTER = "SELECTED_FEEDBACK_FILTER";
export const SELECTED_RUM = "SELECTED_RUM";

export const FEEDBACK_TOKEN_VERIFICATION_LOADING = "FEEDBACK_TOKEN_VERIFICATION_LOADING";
export const FEEDBACK_TOKEN_VERIFICATION_ERROR = "FEEDBACK_TOKEN_VERIFICATION_ERROR";
export const FEEDBACK_TOKEN_VERIFICATION_SUCCESS = "FEEDBACK_TOKEN_VERIFICATION_SUCCESS";

export const FEEDBACK_ASSET_DETAILS_LOADING = "FEEDBACK_ASSET_DETAILS_LOADING";
export const FEEDBACK_ASSET_DETAILS_ERROR = "FEEDBACK_ASSET_DETAILS_ERROR";
export const FEEDBACK_ASSET_DETAILS_RESPONSE = "FEEDBACK_ASSET_DETAILS_RESPONSE";

// OIL REPORT
export const OIL_TEST_REPORT_FILES = "OIL_TEST_REPORT_FILES";
export const UPDATE_OIL_TEST_REPORT_FILES = "UPDATE_OIL_TEST_REPORT_FILES";
export const OIL_TEST_REPORT_FILES_ERROR = "OIL_TEST_REPORT_FILES_ERROR";
export const OIL_TEST_REPORT_FILES_LOADING = "OIL_TEST_REPORT_FILES_LOADING";
export const UPLOAD_OIL_TEST_REPORT = "UPLOAD_OIL_TEST_REPORT";
export const UPLOAD_OIL_TEST_REPORT_ERROR = "UPLOAD_OIL_TEST_REPORT_ERROR";
export const UPLOAD_OIL_TEST_REPORT_LOADING = "UPLOAD_OIL_TEST_REPORT_LOADING";

export const SUPER_ASSET_DETAILS = "SUPER_ASSET_DETAILS";
export const SUPER_ASSET_DETAILS_ERROR = "SUPER_ASSET_DETAILS_ERROR";
export const SUPER_ASSET_DETAILS_LOADING = "SUPER_ASSET_DETAILS_LOADING";